<template>
  <div class="er-page">
    <div class="err-txt">您访问的页面似乎是空的，将跳转到首页 </div>
    <img class="error-img" src="../assets/img/404.png">   
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      this.$router.replace('/')
    }, 2000);
  }
}
</script>

<style scoped>
.er-page {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.err-txt {
  font-size: 16px;
  text-align: center;
  margin-top: 30px;
  color: #65AE71;
}

.error-img {
  margin-top: 20px;
  width: 243px;
  height: 154px;
  margin-bottom: 100px;
}
</style>

